import React from "react";
import { Query, QueryResult } from "react-apollo";
import {
  AdminInsightsProductInfo,
  AdminSharedInsightsProductInfo,
  InsightsProduct,
} from "../../fragments/product";
import gql from "graphql-tag";

const searchAdminInsightsProductsQuery = gql`
  query SearchAdminInsightsProducts(
    $limit: Int
    $query: String!
    $offset: Int
    $reportType: String
  ) {
    products: searchAdminInsightsProducts(
      limit: $limit
      query: $query
      offset: $offset
      reportType: $reportType
    ) {
      ... on AdminInsightsProduct {
        ...AdminInsightsProductInfo
      }
      ... on AdminSharedInsightsProduct {
        ...AdminSharedInsightsProductInfo
      }
    }
  }
  ${AdminInsightsProductInfo}
  ${AdminSharedInsightsProductInfo}
`;

interface SearchAdminInsightsProductsQueryResult {
  products: InsightsProduct[];
}

interface SearchAdminInsightsProductsProps {
  children: (
    queryResult: QueryResult<SearchAdminInsightsProductsQueryResult>
  ) => React.ReactNode;
  limit?: number;
  query: string;
  reportType: string | null;
}

const SearchAdminInsightsProducts: React.FC<SearchAdminInsightsProductsProps> =
  (props) => {
    const { children, limit, query, reportType } = props;

    return (
      <Query
        query={searchAdminInsightsProductsQuery}
        variables={{ limit, query, reportType }}
        fetchPolicy="network-only"
      >
        {(queryResult: QueryResult<SearchAdminInsightsProductsQueryResult>) => {
          return children(queryResult);
        }}
      </Query>
    );
  };

export default SearchAdminInsightsProducts;
